import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../i18n";

const KEY = "boxly-cookie-consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [choice, setChoice] = useState("pending");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (saved === "accepted" || saved === "rejected") setChoice(saved);
    } catch (e) {}
  }, []);

  const set = (val) => {
    try { localStorage.setItem(KEY, val); } catch (e) {}
    setChoice(val);
    // Respect consent for PostHog if present on the page
    try {
      if (window.posthog) {
        if (val === "accepted") window.posthog.opt_in_capturing?.();
        else window.posthog.opt_out_capturing?.();
      }
    } catch (e) {}
  };

  // Default: opt-out until user accepts
  useEffect(() => {
    if (choice === "pending") {
      try { window.posthog && window.posthog.opt_out_capturing?.(); } catch (e) {}
    }
  }, [choice]);

  return (
    <AnimatePresence>
      {choice === "pending" && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink text-white shadow-2xl"
          role="dialog"
          aria-live="polite"
          data-testid="cookie-banner"
        >
          <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-5 py-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
            <p className="max-w-3xl font-body text-sm leading-relaxed text-white/80">
              {t.cookie.banner}{" "}
              <Link to="/cookie-policy" className="underline underline-offset-2 hover:text-lime-accent" data-testid="cookie-more">
                {t.cookie.more}
              </Link>
            </p>
            <div className="flex flex-wrap gap-2">
              <button onClick={() => set("rejected")} className="rounded-md border border-white/30 px-5 py-2.5 font-grotesk text-sm font-semibold text-white transition-colors hover:border-white hover:bg-white/10" data-testid="cookie-reject">
                {t.cookie.reject}
              </button>
              <button onClick={() => set("accepted")} className="rounded-md bg-lime-accent px-5 py-2.5 font-grotesk text-sm font-bold text-ink transition-transform hover:scale-[1.02]" data-testid="cookie-accept">
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
